module.exports = __webpack_public_path__ + "static/media/Apiwe.5d2d0d36.jpg";